import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cw-object-field-templates',
  templateUrl: './object-field-templates.component.html',
  styleUrls: ['./object-field-templates.component.scss']
})
export class ObjectFieldTemplatesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/settings/object-field-templates/object-field-templates.component.ts